module.exports = __webpack_public_path__ + "234b5e85aec0997439a3051a689398f1.woff";